import http from './httpService';
import { appDataStore } from '../constants';

export function register(user) {
  return http.post(appDataStore.apiConfig.AuthSignUp.url, user);
}
